import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import Notification from './Notification';
import './Tickets.css';
import { isVisible } from '@testing-library/user-event/dist/utils';
import flower2 from '../src/pics/flowers2.png';
import flower1 from '../src/pics/flowers3.png';
import wolf from '../src/pics/wolf.png';
import flowertickets from '../src/pics/flowertickets.png';
import { concertsData, getTicketsForCity } from './concertsData';

Modal.setAppElement('#root');
export default class Home extends Component {

  // формирование способа получения данных
  constructor(props) {
    super(props);
    this.state = {
        cities: null,
        tickets: null,
        selectedTickets: [],
        isModalOpen: false,
        cardNumber: '',
        cardExpiry: '',
        cardCVV: '',
        cardEmail: '',
        errors: {},
        notification: {
          message: '',
          type: '',
          isVisible: false
        }
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    this.userToken = localStorage.getItem('userToken');

    const params = new URLSearchParams(window.location.search);
    const cityName = params.get('city');

    const cityInfo = concertsData.find(c => c.name === cityName);

    this.setState({ cities: concertsData });

    if (cityInfo) {
        const generatedTickets = getTicketsForCity(cityInfo.id, cityName);
        
        const updatedTickets = generatedTickets.map(ticket => {
            if (ticket.status === 'sold') {
                return { ...ticket, selected: true };
            }
            return ticket;
        });

        this.setState({ tickets: updatedTickets });
    }
  }

  changeClass = (event) => {
    const target = event.currentTarget;
    const ticketId = target.getAttribute('data-id');
    
    if (target.getAttribute('data-status') !== 'sold') {
      this.setState(prevState => {
        const updatedTickets = prevState.tickets.map(ticket => {
          if (ticket.id === ticketId) { 
            return { ...ticket, selected: !ticket.selected };
          }
          return ticket;
        });

        const selectedTickets = updatedTickets.filter(ticket => 
          ticket.selected && ticket.status !== 'sold'
        );
        return { tickets: updatedTickets, selectedTickets: selectedTickets };
      }, this.updateSelectedTickets);
    }
  }

  updateSelectedTickets() {
    // const selectedSpans = document.querySelectorAll('.ticketid-1.selected, .ticketid-2.selected, .ticketid-3.selected, .ticketid-4.selected');
    const selectedTicketsDiv = document.querySelector('.buyticketsbutinfoblocksod');
    const totalAmountSpan = document.getElementById('totalAmount');
    selectedTicketsDiv.innerHTML = '';
    let totalAmount=0;
    this.state.selectedTickets.forEach(ticket => {
      const ticketElement = document.createElement('p');
      ticketElement.classList.add('elementsinbuyinfotickets');
      ticketElement.textContent = `Место ${ticket.number}, ряд ${ticket.row}, стоимость ${ticket.cost}`;
      selectedTicketsDiv.appendChild(ticketElement);
      totalAmount+=parseFloat(ticket.cost);
    });
    totalAmountSpan.textContent=totalAmount.toFixed(2);
  }

  // Запрос для обновления данных таблицы tickets
  updateTicket(id,ticketData) {
    fetch(`http://localhost:8080/tickets/${id}`, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken,
        'Authorization': `Bearer ${this.userToken}`,
      },
      credentials: 'include',
      body:JSON.stringify(ticketData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(response.status);
      }
      return response.json();
    })
    .then(data => {
      this.setState(prevState => ({
        tickets: prevState.tickets.map(ticket => ticket.id === id ? data : ticket
        )
      }));
    })
    .catch(error => {
      console.error('Error updating ticket:', error.message);
    });
  }

  toogleTicketsSelection=(id)=>{
    this.setState(prevState=>({
      tickets: prevState.tickets.map(ticket=>
        ticket.id===id?{...ticket, selected: !ticket.selected} : ticket
      )
    }));
  }

  handleSubmit = (event) => {
    event.preventDefault();
    
    this.setState(prevState => ({
      tickets: prevState.tickets.map(t => 
        t.selected ? { ...t, status: 'sold', selected: true } : t
      ),
      selectedTickets: [] // Очищаем корзину
    }));
  }

  // функция для форматирования даты перед выводом её на страницу
  formatDate(date) {
    const months=["января","февраля","марта","апреля","мая","июня","июля","августа","сентября","октября","ноября","декабря"];
    const chapters=date.split('-');
    const m=chapters[1];
    const d=chapters[2];
    const monthsspi=parseInt(m,10)-1;
    return `${d} ${months[monthsspi]}`;
  };

  // функция для форматирвоанного вывода времени
  formatTime(time, dur) {
    if (!time) return "00:00"; // Если времени нет, возвращаем заглушку
    
    const ch = time.split(':');
    let hour = ch[0];
    let nh = Number(hour) + (dur || 2); // Если длительность не передана, берем 2 часа
    let min = ch[1];
    return `${hour}:${min} - ${nh}:${min}`;
  };

  toggleModal=()=>{
    if (this.state.selectedTickets.length===0) {
      this.setState({
        notification: {
          message: 'Список билетов пуст. Пожалуйста, выберите хотя бы один билет',
          type: 'error',
          isVisible: true
        }
      });
      return;
    }
    this.setState(prevState=>({
      isModalOpen: !prevState.isModalOpen,
      errors: {}
    }));
  }

  handleInputChange=(e)=>{
    const { name, value } = e.target;
    this.setState({
      [name]: value
    });
  }

  handleInputBlur=(e)=>{
    const { name, value } = e.target;
    this.validateInput(name,value);
  }

  validateInput=(name,value)=>{
    const { errors }=this.state;
    const newErrors={...errors};
    switch (name) {
      case 'cardNumber':
        newErrors.cardNumber=/^\d{16}$/.test(value)?'':'Введите правильный номер карты (16 цифр)';
        break;
      case 'cardExpiry':
        newErrors.cardExpiry=/^(0[1-9]|1[0-2])\/?([0-9]{2})$/.test(value)?'':'Введите правильный срок действия карты (ММ/ГГ)';
        break;
      case 'cardCVV':
        newErrors.cardCVV=/^[0-9]{3,4}$/.test(value)?'':'Введите правильный CVV (3 или 4 цифры)';
        break;
      case 'cardEmail':
        newErrors.cardEmail=/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)?'':'Введите правильный адрес электронной почты';
        break;
      default:
        break;
    }
    this.setState({errors:newErrors});
  }

  validateInputs=()=>{
    const { cardNumber, cardExpiry, cardCVV, cardEmail } = this.state;
    const errors={};
    errors.cardNumber = /^\d{16}$/.test(cardNumber)?'':'Введите правильный номер карты (16 цифр)';
    errors.cardExpiry = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/.test(cardExpiry)?'':'Введите правильный срок действия карты (ММ/ГГ)';
    errors.cardCVV = /^[0-9]{3,4}$/.test(cardCVV)?'':'Введите правильный CVV (3 или 4 цифры)';
    errors.cardEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cardEmail)?'':'Введите правильный адрес электронной почты';

    this.setState({ errors });
    return Object.keys(errors).every(key=>errors[key]==='');
  }

  handlePayment=(event)=>{
    event.preventDefault();
    if (this.validateInputs()) {
      this.setState({
        notification: {
          message: 'Оплата прошла успешно',
          type: 'success',
          isVisible: true
        }
      });
      this.toggleModal();
      this.handleSubmit(event);
      setTimeout(()=>{
        window.location.reload();
      },1300);
    }
  }

  closeNotification=()=>{
    this.setState({
      notification: {
        message: '',
        type: '',
        isVisible: false
      }
    });
  }

  select = (event) => {
    event.preventDefault(); // Добавим, чтобы страница не прыгала
    const content = event.currentTarget.textContent.trim();
    const url = new URL(window.location);
    url.searchParams.set('city', content);
    // Убираем action=buy при смене города, чтобы вернуться к инфо о концерте
    url.searchParams.delete('action'); 
    
    window.history.pushState({}, '', url);
    
    // Вызываем componentDidMount, чтобы обновить состояние билетов для нового города
    this.componentDidMount(); 
  };

  // Метод перехода к покупке
  buyticket = (event) => {
    event.preventDefault();
    const params = new URLSearchParams(window.location.search);
    params.set('action', 'buy');
    // Используем history вместо window.location.search, чтобы не перезагружать страницу полностью
    window.history.pushState({}, '', `?${params.toString()}`);
    this.componentDidMount();
  };

  render() {

    // ищем, какой город нам нужно вывести на экран (так же идёт поиск
    // значений для покупки билетов и вывода адреса площадки)
    const { errors, notification } = this.state;
    const params = new URLSearchParams(window.location.search);
    const city=params.get('city');
    const act=params.get('action');
    const addr=window.location.search;
    let ur=new URLSearchParams(addr);
    let prop=ur.get('city');
    
    if (prop!==null&&act===null) {
    return (
      <div className="main">
        <section>
          <div className='ticketsbody'>
            <img className='ticketsbodyimg' src={flowertickets} />
            {/* получение данных из базы */}
            {this.state.cities !== null ?
            this.state.cities.filter(elem => elem.name===city).map(elem =>
            <div className='ticketsbodyinfo' key={elem.name}>
              <p className='ticketsbodyinfocity'>
                {elem.name}
              </p>
              <p className='ticketsbodyinfodate'>
                {this.formatDate(elem.concertdate)}
              </p>
              <p className='ticketsbodyinfotime'>
                {elem.time_start ? this.formatTime(elem.time_start, elem.duration || 2) : "Время не указано"}
              </p>
              <img className='ticketsbodyinfoimg' src={elem.image} alt='' />
              <p className='ticketsbodyinfoaddress'>
                {elem.address}
              </p>
              <Link to='#' className='ticketsbodyinfobuy' onClick={this.buyticket}>
                ВЫБРАТЬ БИЛЕТЫ
              </Link>
            </div>
            ) : null }
            <div className='age_category'>
              <img className='ticketsbodyinfolamp' src={wolf} />
              <p className='ticketsbodyinfoage'>
                16+
              </p>
            </div>
          </div>
          <div className='footer'>
            <div className='footerleft'>
              <div className='footerleftline'>
                <Link to="" className='footerleftlinechapters vk' onClick={(e) => this.selectsong(e,'https://vk.com/lampabikt')} />
                <Link to=""  className='footerleftlinechapters yt' onClick={(e) => this.selectsong(e,'https://www.youtube.com/channel/UCpYDcaEQw6RQ-t_3CGidJuQ')} />
                <Link to=""  className='footerleftlinechapters tg' onClick={(e) => this.selectsong(e,'https://t.me/lampabikt')} />
                <Link to=""  className='footerleftlinechapters tt' onClick={(e) => this.selectsong(e,'https://www.tiktok.com/@lampabikt?is_from_webapp=1&sender_device=pc')} />
              </div>
              <div className='footerleftname'>
                <p className='footerleftnametext'>
                  лампабикт.
                </p>
              </div>
            </div>
            <div className='footercenter'>
              <a className='footercenterimg' />
            </div>
            <div className='footerright'>
              <div className='footerrightline'>
                <p className='footerrightlinetext'>ИКОНКИ ОТ <a className='footerrightlinetextlinkus' href='https://icons8.ru/icons' target='_blank' rel='noopener noreferrer'>ICONS8</a></p>
                <p className='footerrightlinetext'>СВЯЗАТЬСЯ С НАМИ: <a className='link_to_email' href="mailto:lampabikt@gmail.com">LAMPABIKT@GMAIL.COM</a></p>
                <p className='footerrightlinetext'>МЕНЕДЖЕР: АЛЕКСАНДРА</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    )} else if (prop===null&&act===null) { 
    return (
      <div className="main">
        <section>
          <div className='ticketsbody'>
            <img className='ticketsbodychangeimg1' alt='' src={flower1} />
            <div className='ticketsbodychange'>
              <p className='takecity'>
                Предстоящие концерты:
              </p>
              {this.state.cities !== null ?
              this.state.cities.map(elem=>
                <Link to='' className='takecityc' onClick={this.select} key={elem.name}>
                  {elem.name}
                </Link>
              ) : null }
            </div>
            <img className='ticketsbodychangeimg2' alt='' src={flower2} />
          </div>
          <div className='footer'>
            <div className='footerleft'>
              <div className='footerleftline'>
                <Link to="" className='footerleftlinechapters vk' onClick={(e) => this.selectsong(e,'https://vk.com/lampabikt')} />
                <Link to=""  className='footerleftlinechapters yt' onClick={(e) => this.selectsong(e,'https://www.youtube.com/channel/UCpYDcaEQw6RQ-t_3CGidJuQ')} />
                <Link to=""  className='footerleftlinechapters tg' onClick={(e) => this.selectsong(e,'https://t.me/lampabikt')} />
                <Link to=""  className='footerleftlinechapters tt' onClick={(e) => this.selectsong(e,'https://www.tiktok.com/@lampabikt?is_from_webapp=1&sender_device=pc')} />
              </div>
              <div className='footerleftname'>
                <p className='footerleftnametext'>
                  лампабикт.
                </p>
              </div>
            </div>
            <div className='footercenter'>
              <a className='footercenterimg' />
            </div>
            <div className='footerright'>
              <div className='footerrightline'>
                <p className='footerrightlinetext'>ИКОНКИ ОТ <a className='footerrightlinetextlinkus' href='https://icons8.ru/icons' target='_blank' rel='noopener noreferrer'>ICONS8</a></p>
                <p className='footerrightlinetext'>СВЯЗАТЬСЯ С НАМИ: <a className='link_to_email' href="mailto:lampabikt@gmail.com">LAMPABIKT@GMAIL.COM</a></p>
                <p className='footerrightlinetext'>МЕНЕДЖЕР: АЛЕКСАНДРА</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    )} else if ((prop!==null&&act!==null)) {
      return (
        <div className='main'>
          <section>
            <div className='buyticketsbuy'>
              <div className='buyticketsbuyplaces'>
                {this.state.tickets !== null ?
                  Object.entries(
                    this.state.tickets
                      .filter(elem => elem.name === city)
                      .reduce((acc, elem) => {
                        if (!acc[elem.row]) {
                          acc[elem.row] = [];
                        }
                        acc[elem.row].push(elem);
                        return acc;
                      }, {})
                  ).map(([row, rowGroup], index) => (
                    <div key={index} className={`buyticketsbuyrow row-${row}`}>
                      {rowGroup.map(ticket => (
                        <span key={ticket.id}
                        className={`ticketid-${ticket.typeid} ${ticket.selected ? 'selected' : ''} ${ticket.status==='sold' ? 'unclickable' : ''}`}
                        data-id={ticket.id}
                        data-status={ticket.status}
                        data-number={ticket.number}
                        data-row={ticket.row}
                        data-cost={ticket.cost}
                        onClick={ticket.status!=='sold' ? this.changeClass:null}
                        >
                        </span>
                      ))}
                    </div>
                  )) : null}
              </div>
              <div className='buyticketsbuyspi'>
                <div className='buyticketbuyinfo'>
                  <div className='buyticketbuyinfo1'>
                    <span className='ticketid--1'></span>
                    <p className='ticketidtxt'>
                      Билеты категории "Танцпол"
                    </p>
                    <div className='ticketidinfo' title='Погрузись в ритмы музыки на танцполе! Ощути энергию толпы и танцуй под любимые хиты.'>
                      <p className='ticketidinfotxt'>
                        !
                      </p>
                    </div>
                  </div>
                  <div className='buyticketbuyinfo1'>
                    <span className='ticketid--2'></span>
                    <p className='ticketidtxt'>
                      Билеты категории "Фан Зона"
                    </p>
                    <div className='ticketidinfo' title="Насладись выступлением ближе к сцене! Фан Зона — идеальное место для преданных поклонников.">
                      <p className='ticketidinfotxt'>
                        !
                      </p>
                    </div>
                  </div>
                  <div className='buyticketbuyinfo1'>
                    <span className='ticketid--3'></span>
                    <p className='ticketidtxt'>
                      Билеты категории "Вип"
                    </p>
                    <div className='ticketidinfo' title="Получи эксклюзивный доступ к лучшим местам и автографы от любимых исполнителей! VIP-билет — твой пропуск в мир комфорта и роскоши.">
                      <p className='ticketidinfotxt'>
                        !
                      </p>
                    </div>
                  </div>
                  <div className='buyticketbuyinfo1'>
                    <span className='ticketid--4'></span>
                    <p className='ticketidtxt'>
                      Билеты категории "Супер Вип"
                    </p>
                    <div className='ticketidinfo' title="Ощути премиальный опыт с наилучшими удобствами, фанатской фотосессией и автографами. Супер VIP — это высший класс.">
                      <p className='ticketidinfotxt'>
                        !
                      </p>
                    </div>
                  </div>
                </div>
                <div className='buyticketsbutinfoblock'>
                  <p className='buyticketsbutinfoblocksodtext'>
                    Выбранные билеты: 
                  </p>
                  <div className='buyticketsbutinfoblocksod'>
                    {this.state.selectedTickets.map((ticket, idx) => (
                      <p key={idx} className='elementsinbuyinfotickets'>
                        Место {ticket.number}, ряд {ticket.row}, стоимость {ticket.cost} руб.
                      </p>
                    ))}
                  </div>
                  <p className='total-amount'>
                    Итоговая сумма: 
                    <span id='totalAmount'>
                      {this.state.selectedTickets.reduce((sum, t) => sum + parseFloat(t.cost), 0).toFixed(2)}
                    </span>
                  </p>
                </div>
                <div className='buyticketsbutinfoblockbuy'>
                  {/* <button type='submit' onClick={this.handleSubmit}>ОПЛАТИТЬ</button> */}
                  <button type='submit' onClick={this.toggleModal}>ОПЛАТИТЬ</button>
                </div>
                <Modal isOpen={this.state.isModalOpen} onRequestClose={this.toggleModal} className='ticket_modal'>
                  <div className='modal_content'>
                    <h2 className='ticketmodal_txt'>Оплатить заказ</h2>
                    <form className='ticketmodal_form'>
                      <div className='ticketmodal_inputstr'>
                        <label htmlFor='cardNumber' className='ticketmodal_label'>Номер карты:</label>
                        <input type='text' maxLength={16} id='cardNumber' className='ticketmodal_input' name='cardNumber' value={this.state.cardNumber} onChange={this.handleInputChange} onBlur={this.handleInputBlur} required />
                      </div>
                      {errors.cardNumber&&<p className='ticket_error'>{errors.cardNumber}</p>}
                      <div className='ticketmodal_inputstr'>
                        <label htmlFor='cardExpiry' className='ticketmodal_label'>Срок действия:</label>
                        <input type='text' maxLength={5} id='cardExpiry' className='ticketmodal_input' name='cardExpiry' value={this.state.cardExpiry} onChange={this.handleInputChange} onBlur={this.handleInputBlur} required />
                      </div>
                      {errors.cardExpiry&&<p className='ticket_error'>{errors.cardExpiry}</p>}
                      <div className='ticketmodal_inputstr'>
                        <label htmlFor='cardCVV' className='ticketmodal_label'>CVV:</label>
                        <input type='text' maxLength={4} id='cardCVV' className='ticketmodal_input' name='cardCVV' value={this.state.cardCVV} onChange={this.handleInputChange} onBlur={this.handleInputBlur} required />
                      </div>
                      {errors.cardCVV&&<p className='ticket_error'>{errors.cardCVV}</p>}
                      <div className='ticketmodal_inputstr'>
                        <label htmlFor='cardEmail' className='ticketmodal_label'>Email для квитанции:</label>
                        <input type='text' id='cardEmail' className='ticketmodal_input' name='cardEmail' value={this.state.cardEmail} onChange={this.handleInputChange} onBlur={this.handleInputBlur} required />
                      </div>
                      {errors.cardEmail&&<p className='ticket_error'>{errors.cardEmail}</p>}
                      <button type='button' onClick={this.handlePayment} className='ticketmodal_button_pay'>Оплатить</button>
                      </form>
                    <button onClick={this.toggleModal} className='ticketmodal_button_close'>Отмена</button>
                  </div>
                </Modal>
                {notification.isVisible&&(
                  <Notification message={notification.message} type={notification.type} onClose={this.closeNotification} />
                )}
              </div>
            </div>
            <div className='footer'>
              <div className='footerleft'>
                <div className='footerleftline'>
                  <Link to="" className='footerleftlinechapters vk' onClick={(e) => this.selectsong(e,'https://vk.com/lampabikt')} />
                  <Link to=""  className='footerleftlinechapters yt' onClick={(e) => this.selectsong(e,'https://www.youtube.com/channel/UCpYDcaEQw6RQ-t_3CGidJuQ')} />
                  <Link to=""  className='footerleftlinechapters tg' onClick={(e) => this.selectsong(e,'https://t.me/lampabikt')} />
                  <Link to=""  className='footerleftlinechapters tt' onClick={(e) => this.selectsong(e,'https://www.tiktok.com/@lampabikt?is_from_webapp=1&sender_device=pc')} />
                </div>
                <div className='footerleftname'>
                  <p className='footerleftnametext'>
                    лампабикт.
                  </p>
                </div>
              </div>
              <div className='footercenter'>
                <a className='footercenterimg' />
              </div>
              <div className='footerright'>
                <div className='footerrightline'>
                  <p className='footerrightlinetext'>ИКОНКИ ОТ <a className='footerrightlinetextlinkus' href='https://icons8.ru/icons' target='_blank' rel='noopener noreferrer'>ICONS8</a></p>
                  <p className='footerrightlinetext'>СВЯЗАТЬСЯ С НАМИ: <a className='link_to_email' href="mailto:lampabikt@gmail.com">LAMPABIKT@GMAIL.COM</a></p>
                  <p className='footerrightlinetext'>МЕНЕДЖЕР: АЛЕКСАНДРА</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      )
    }
    return null;
  };
};